<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage">
            <b-row style="margin-top:100px;text-align: left;">
                <b-col>
                     <span v-if="input_type === 0">
                        <h3>Details of Experiment Pair {{humanRunId+':'+mouseRunId}}</h3>
                     </span>
                     <span v-if="input_type === 1">
                        <h3>Details of {{speciesName+''}}</h3>
                     </span>
                     <span v-if="input_type === 2">
                        <h3>Details of {{genusName+''}}</h3>
                     </span>
                </b-col>
            </b-row>
            <b-row style="text-align: left;" v-if="input_type === 0 && hasHmPair">
                <b-col>
                    <div id="boxBg">
                    <ul>
                        <li> <b>BioProject :</b><a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + hmPairInfo.bioProject" target="_blank">{{hmPairInfo.bioProject}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a></li>
                        <li> <b>Mouse Entropy group :</b> {{hmPairInfo.mouseEnterotype}} </li>
                        <li> <b>Human Entropy group :</b> {{hmPairInfo.humanEnterotype}} </li>
                        <li> <b>Dietry condition :</b> {{hmPairInfo.condition}} </li>
                        <li> <b>Fed method :</b> {{hmPairInfo.fedMethod}} </li>
                        <li> Total species observed <b> {{rel_spe_abn_data.length}} </b>  and total genus observed <b> {{rel_gen_abn_data.length}} </b></li>
                    </ul>
                    </div>
                </b-col>
            </b-row>
            <!-- <b-row style="text-align: left; margin-bottom:5px;" v-if="input_type === 1">
                <b-col>
                    <div id="boxBg">
                        <ul>
                            <li> Total <b> {{totalProjects}} </b> Projects. </li>
                            <li> Total <b> {{totalExp}} </b> Experiments. </li>
                        </ul>
                    </div>
                </b-col>
                <br/>
            </b-row> -->
            <!-- <b-row style="text-align: left;" v-if="input_type === 2">
                <b-col>
                    <div id="boxBg">
                    </div>
                </b-col>
            </b-row> -->
            <b-row style="text-align: left;">                
                <b-row>
                    <span v-if="input_type === 0">
                        <b-col>
                            <Plotly :data="retRateGraphDat" :layout="retLayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                        </b-col>
                    </span>
                </b-row>
            </b-row>
            <b-row style="text-align: left;">
                    <span v-if="input_type === 0">
                        <b-row>
                            <b-col>
                                <h4><font-awesome-icon icon="list-alt" size='sm'></font-awesome-icon>&nbsp; Relative abundances</h4>
                            </b-col>
                        </b-row>
                        
                        <b-row>                            
                        </b-row>
                    </span>
            </b-row>
            <b-row style="text-align: left;">
            <span v-if="input_type === 0">
            <b-tabs
                active-nav-item-class="font-weight-bold text-uppercase"
                active-tab-class="font-weight-bold text-success"
                justified
            >
            <b-tab>
                <template v-slot:title>
                    <font-awesome-icon icon="list-ul" size="2x"></font-awesome-icon> Associated Species
                </template>
                <b-row>
                    <!-- <b-col>
                        <Plotly :data="speRelAbundGraph" :layout="speRelAbundLayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                    </b-col> -->
                </b-row>
                <b-row style="margin-top:10px;margin-bottom:10px">
                    <b-col style="align:left">                       
                        <b-input-group>
                            <b-form-input
                            v-model="rel_spe_abn_filter"
                            type="search"
                            id="filterSpecies"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!rel_spe_abn_filter" @click="rel_spe_abn_filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col style="margin-top:5px;">
                        <download-csv
                            :data   = "rel_spe_abn_data">
                            Download Data
                        <font-awesome-icon icon="download"></font-awesome-icon>
                        </download-csv>
                    </b-col>
                </b-row>    
                <b-row>
                    <b-col>                    
                        <b-table
                            responsive
                            show-empty
                            :busy.sync="rel_spe_abn_isBusy"
                            :striped="false"
                            :outlined="true"
                            :items="rel_spe_abn_data"
                            :fields="rel_spe_abn_fields"
                            :current-page="rel_spe_abn_currentPage"
                            :per-page="rel_spe_abn_perPage"
                            :filter="rel_spe_abn_filter"
                        >
                            <template  v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(index)="data">
                                <span v-if="rel_spe_abn_currentPage>1">{{ data.index + 1 +(rel_spe_abn_currentPage*rel_spe_abn_perPage)-rel_spe_abn_perPage}}</span>
                                <span v-else>{{ data.index + 1 }}</span>
                            </template>
                            <template v-slot:cell(Species)="data">
                                    {{data.item.Species}} <router-link :to="{ path: '/viewpair/sp/'+data.item.Species}" target="_blank">
                                    <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link> 
                            </template>
                        </b-table>
                        <b-row>
                                <b-col md="6" class="my-1">
                                    <b-pagination
                                    v-model="rel_spe_abn_currentPage"
                                    :total-rows="relSpetotalRows"
                                    :per-page="rel_spe_abn_perPage"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>
                                <b-col md="6" class="my-1">
                                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                    <b-form-select v-model="rel_spe_abn_perPage" :options="relSpepageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                </b-tab>
            <b-tab>
                <template v-slot:title>
                    <font-awesome-icon icon="list-ul" size="2x"></font-awesome-icon> Associated Genus
                </template>
            <b-row>
                <!-- <b-col>
                    <Plotly :data="genRelAbundGraph" :layout="genRelAbundLayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                </b-col> -->
            </b-row>
            <b-row style="margin-top:10px;margin-bottom:10px">
                    <b-col style="align:left">                        
                        <b-input-group>
                            <b-form-input
                            v-model="rel_gen_abn_filter"
                            type="search"
                            id="filteGenus"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!rel_gen_abn_filter" @click="rel_gen_abn_filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col style="margin-top:5px;">
                        <download-csv
                            :data   = "rel_gen_abn_data">
                            Download Data
                        <font-awesome-icon icon="download"></font-awesome-icon>
                        </download-csv>
                    </b-col>
                </b-row>
            <b-row>
                <b-col>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="rel_gen_abn_isBusy"
                        :striped="false"
                        :outlined="true"
                        :items="rel_gen_abn_data"
                        :fields="rel_gen_abn_fields"
                        :current-page="rel_gen_abn_currentPage"
                        :per-page="rel_gen_abn_perPage"
                        :filter="rel_gen_abn_filter"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(index)="data">
                            <span v-if="rel_gen_abn_currentPage>1">{{ data.index + 1 +(rel_gen_abn_currentPage*rel_gen_abn_perPage)-rel_gen_abn_perPage}}</span>
                            <span v-else>{{ data.index + 1 }}</span>
                        </template>
                        <template v-slot:cell(Genus)="data">
                            {{data.item.Genus}} <router-link :to="{ path: '/viewpair/gen/'+data.item.Genus}" target="_blank">
                            <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link> 
                        </template>
                    </b-table>
                     <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="rel_gen_abn_currentPage"
                                :total-rows="relGentotalRows"
                                :per-page="rel_gen_abn_perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="rel_gen_abn_perPage" :options="relGenpageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-tab>
            </b-tabs>
            </span>            
            <span v-if="input_type === 1">
                <b-row style="text-align: left;">
                        <b-row>
                            <b-col>
                                <h4><font-awesome-icon icon="chart-bar" size='sm'></font-awesome-icon>&nbsp; Statistics</h4>
                            </b-col>
                        </b-row>
                        
                        <b-row>                            
                        </b-row>
                </b-row>
                <b-row>
                    <b-col>
                        <Plotly :data="speRelAbundGraphBx" :layout="spRelAbLayoutBx" :display-mode-bar="false" :autoResize="true"></Plotly>
                    </b-col>
                </b-row>
                <b-row style="text-align: left;">
                        <b-row>
                            <b-col>
                                <h4><font-awesome-icon icon="list-alt" size='sm'></font-awesome-icon>&nbsp; Relative abundances</h4>
                            </b-col>
                        </b-row>                        
                </b-row>
                <b-row style="margin-top:10px;margin-bottom:10px">
                    <b-col style="align:left">                       
                        <b-input-group>
                            <b-form-input
                            v-model="rel_spe_abn_filter"
                            type="search"
                            id="filterSpecies"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!rel_spe_abn_filter" @click="rel_spe_abn_filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col style="margin-top:5px;">
                        <download-csv
                            :data   = "rel_spe_abn_data">
                            Download Data
                        <font-awesome-icon icon="download"></font-awesome-icon>
                        </download-csv>
                    </b-col>
                </b-row>    
                <b-row>
                    <b-col>                    
                        <b-table
                            responsive
                            show-empty
                            :busy.sync="rel_spe_abn_isBusy"
                            :striped="false"
                            :outlined="true"
                            :items="rel_spe_abn_data"
                            :fields="rel_spe_abn_fields"
                            :current-page="rel_spe_abn_currentPage"
                            :per-page="rel_spe_abn_perPage"
                            :filter="rel_spe_abn_filter"
                        >
                            <template  v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(index)="data">
                                <span v-if="rel_spe_abn_currentPage>1">{{ data.index + 1 +(rel_spe_abn_currentPage*rel_spe_abn_perPage)-rel_spe_abn_perPage}}</span>
                                <span v-else>{{ data.index + 1 }}</span>
                            </template>
                            <template v-slot:cell(viewpair)="data">
                                <router-link :to="{ path: '/viewpair/p/'+data.item.humanRun.trim()+'/'+data.item.mouseRun.trim()}" target="_blank" >
                                    <b-button size="sm" variant="primary">View</b-button>
                                </router-link> 
                            </template>
                            <template v-slot:cell(humanRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.humanRun.trim()" target="_blank">{{row.item.humanRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:cell(mouseRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.mouseRun.trim()" target="_blank">{{row.item.mouseRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                        </b-table>
                        <b-row>
                                <b-col md="6" class="my-1">
                                    <b-pagination
                                    v-model="rel_spe_abn_currentPage"
                                    :total-rows="relSpetotalRows"
                                    :per-page="rel_spe_abn_perPage"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>
                                <b-col md="6" class="my-1">
                                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                    <b-form-select v-model="rel_spe_abn_perPage" :options="relSpepageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </span>
            <span v-if="input_type === 2">
                <b-row style="text-align: left;">
                        <b-row>
                            <b-col>
                                <h4><font-awesome-icon icon="chart-bar" size='sm'></font-awesome-icon>&nbsp; Statistics</h4>
                            </b-col>
                        </b-row>
                        
                        <b-row>                            
                        </b-row>
                </b-row>
                <b-row>
                    <b-col>
                        <Plotly :data="genRelAbundGraphBx" :layout="genRelAbLayoutBx" :display-mode-bar="false" :autoResize="true"></Plotly>
                    </b-col>
                </b-row>
                <b-row style="text-align: left;">
                        <b-row>
                            <b-col>
                                <h4><font-awesome-icon icon="list-alt" size='sm'></font-awesome-icon>&nbsp; Relative abundances</h4>
                            </b-col>
                        </b-row>
                        
                        <b-row>                            
                        </b-row>
                </b-row>
                <b-row style="margin-top:10px;margin-bottom:10px">
                    <b-col style="align:left">                        
                        <b-input-group>
                            <b-form-input
                            v-model="rel_gen_abn_filter"
                            type="search"
                            id="filteGenus"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!rel_gen_abn_filter" @click="rel_gen_abn_filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col style="margin-top:5px;">
                        <download-csv
                            :data   = "rel_gen_abn_data">
                            Download Data
                        <font-awesome-icon icon="download"></font-awesome-icon>
                        </download-csv>
                    </b-col>
                </b-row>
            <b-row>
                <b-col>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="rel_gen_abn_isBusy"
                        :striped="false"
                        :outlined="true"
                        :items="rel_gen_abn_data"
                        :fields="rel_gen_abn_fields"
                        :current-page="rel_gen_abn_currentPage"
                        :per-page="rel_gen_abn_perPage"
                        :filter="rel_gen_abn_filter"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(index)="data">
                            <span v-if="rel_gen_abn_currentPage>1">{{ data.index + 1 +(rel_gen_abn_currentPage*rel_gen_abn_perPage)-rel_gen_abn_perPage}}</span>
                            <span v-else>{{ data.index + 1 }}</span>
                        </template>
                        <template v-slot:cell(viewpair)="data">
                                <router-link :to="{ path: '/viewpair/p/'+data.item.humanRun.trim()+'/'+data.item.mouseRun.trim()}" target="_blank" >
                                    <b-button size="sm" variant="primary">View</b-button>
                                </router-link> 
                        </template>
                        <template v-slot:cell(humanRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.humanRun.trim()" target="_blank">{{row.item.humanRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:cell(mouseRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.mouseRun.trim()" target="_blank">{{row.item.mouseRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                    </b-table>
                     <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="rel_gen_abn_currentPage"
                                :total-rows="relGentotalRows"
                                :per-page="rel_gen_abn_perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="rel_gen_abn_perPage" :options="relGenpageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </span>
            </b-row>
        </b-container>
    </div>    
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return{
            server_add:this.$hostname,
            showPage:false,
            loadCounter:0,
            input_type:0,
            humanRunId:'',
            mouseRunId:'',
            speciesName:'',
            genusName:'',
            retRateGraphDat:[],
            retLayout:{
                title:'Retention rate'
            },
            genRelAbundGraph:[],
            genRelAbundLayout:{
                title:'Relative abundance'
            },
            rel_gen_abn_data:[],
            rel_gen_abn_fields:[
                {key:'index',label:''},
                {key:'Genus',label:'Genus',sortable:true},
                {key:'humanRun',label:'Human Experiment ID'},
                {key:'mouseRun',label:'Mouse Experiment ID'},
                {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                { key:'viewpair',label:''},                    
            ],
            rel_gen_abn_isBusy:true,
            rel_gen_abn_currentPage:1,
            rel_gen_abn_perPage:15,
            rel_gen_abn_filter:null,
            relGentotalRows: 1,
            relGenpageOptions: [5, 10, 15,25],
            speRelAbundGraph:[],
            speRelAbundLayout:{
                title:'Relative abundance'
            },
            rel_spe_abn_data:[],
            rel_spe_abn_fields:[
                {key:'index',label:''},
                {key:'Species',label:'Species',sortable:true},
                {key:'humanRun',label:'Human Experiment ID'},
                {key:'mouseRun',label:'Mouse Experiment ID'},
                {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                { key:'viewpair',label:''},                    
            ],
            rel_spe_abn_isBusy:true,
            rel_spe_abn_currentPage:1,
            rel_spe_abn_perPage:15,
            rel_spe_abn_filter:null,
            relSpetotalRows: 1,
            relSpepageOptions: [5, 10, 15,25],
            hmPairInfo:null,
            hasHmPair:false,
            totalSpecies:0,
            totalGenus:0,
            totalProjects:4,
            totalExp:0,
            speRelAbundGraphBx:[],
            spRelAbLayoutBx:{
                title:'Relative abundance across experiments'
            },
            genRelAbundGraphBx:[],
            genRelAbLayoutBx:{
                title:'Relative abundance across experiments'
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            let typ = this.$route.params.p
            let humanId = this.$route.params.humanrun
            let mouseId = this.$route.params.mouserun
            let speciesName = this.$route.params.species
            let genusName = this.$route.params.genus
            // console.log(typ,humanId,mouseId)        
            if(typ === undefined){
                if(speciesName === undefined){
                    this.genusName = genusName
                    this.input_type = 2

                    this.rel_gen_abn_fields = [
                        {key:'index',label:''},
                        {key:'humanRun',label:'Human Experiment ID'},
                        {key:'mouseRun',label:'Mouse Experiment ID'},
                        {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                        {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                        {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                        { key:'viewpair',label:''},                    
                    ]

                    this.loadGenRelAbundance()
                    this.loadGenRelAbundBxPlot()
                }else{
                    this.speciesName = speciesName
                    this.input_type = 1

                    this.rel_spe_abn_fields = [
                        {key:'index',label:''},
                        {key:'humanRun',label:'Human Experiment ID'},
                        {key:'mouseRun',label:'Mouse Experiment ID'},
                        {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                        {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                        {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                        { key:'viewpair',label:''},                    
                    ],
                    this.loadSpeRelAbundance()
                    this.loadSpeRelAbundBxPlot()
                }
            }else {
                this.humanRunId = humanId
                this.mouseRunId = mouseId
                this.input_type = 0

                this.rel_gen_abn_fields = [
                    {key:'index',label:''},
                    {key:'Genus',label:'Genus',sortable:true},
                    {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                    {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                    {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                    { key:'viewpair',label:''},                    
                ]

                this.rel_spe_abn_fields = [
                    {key:'index',label:''},
                    {key:'Species',label:'Species',sortable:true},                    
                    {key:'humanRelativeAbundance',label:'Rel Abundance in Human',sortable:true},
                    {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse',sortable:true},
                    {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                    { key:'viewpair',label:''},                    
                ],

                this.loadStatGRaph()
                this.loadPairGenRelAbundance()
                this.loadPairSpeRelAbundance()
                this.loadPairInfo()
            }            
        },
        loadStatGRaph(){
            axios.post(this.server_add+'query/getRetRate',
            {
                hRunId:this.humanRunId,
                mRunId:this.mouseRunId
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data[0]
                    var trace1 = {
                        x: ['Retention rate', 'Count in human', 'Count in mouse'],
                        y: [inDat.Species_Retention_rate*10, inDat.Species_count_in_human, inDat.Species_count_in_mouse],
                        name: 'Species',
                        type: 'bar'
                    };
                    var trace2 ={
                        x: ['Retention rate', 'Count in human', 'Count in mouse'],
                        y: [inDat.Genus_Retention_rate*10, inDat.Genus_count_in_human, inDat.Genus_count_in_mouse],
                        name: 'Genus',
                        type: 'bar'
                    }
                    this.retRateGraphDat.push(trace1)
                    this.retRateGraphDat.push(trace2)
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadPairGenRelAbundance(){
            axios.post(this.server_add+'query/getGenusRelAbundFPair',
            {
                hRunId:this.humanRunId,
                mRunId:this.mouseRunId
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    var xArr = []
                    var yArrHu = []
                    var yArrMou = []
                    var hoverArr = []
                    this.rel_gen_abn_data = retDat.data
                    this.relGentotalRows = retDat.data.length
                    this.rel_gen_abn_isBusy = false
                    // for(let i=0;i<inDat.length;i++){
                    //     var row = inDat[i]
                    //     xArr.push(i)
                    //     yArrHu.push(row.humanRelativeAbundance)
                    //     yArrMou.push(row.mouseRelativeAbundance)
                    //     hoverArr.push(row.Genus)
                    // }
                    // var trace1 = {
                    //     x: xArr,
                    //     y: yArrHu,
                    //     hovertext:hoverArr,
                    //     name:'Human Rel Abundance',
                    //     type: 'scatter'
                    // };
                    // var trace2 = {
                    //     x: xArr,
                    //     y: yArrMou,
                    //     hovertext:hoverArr,
                    //     name:'Mouse Rel Abundance',
                    //     type: 'scatter'
                    // };
                    // this.genRelAbundGraph.push(trace1)
                    // this.genRelAbundGraph.push(trace2)                    
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadPairSpeRelAbundance(){
            axios.post(this.server_add+'query/getSpeciesRelAbundFPair',
            {
                hRunId:this.humanRunId,
                mRunId:this.mouseRunId
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    var xArr = []
                    var yArrHu = []
                    var yArrMou = []
                    var hoverArr = []
                    this.rel_spe_abn_data = retDat.data
                    this.relSpetotalRows = retDat.data.length
                    this.rel_spe_abn_isBusy = false
                    // for(let i=0;i<inDat.length;i++){
                    //     var row = inDat[i]
                    //     xArr.push(i)
                    //     yArrHu.push(row.humanRelativeAbundance)
                    //     yArrMou.push(row.mouseRelativeAbundance)
                    //     hoverArr.push(row.Species)
                    // }
                    // var trace1 = {
                    //     x: xArr,
                    //     y: yArrHu,
                    //     hovertext:hoverArr,
                    //     name:'Human Rel Abundance',
                    //     type: 'scatter'
                    // };
                    // var trace2 = {
                    //     x: xArr,
                    //     y: yArrMou,
                    //     hovertext:hoverArr,
                    //     name:'Mouse Rel Abundance',
                    //     type: 'scatter'
                    // };
                    // this.speRelAbundGraph.push(trace1)
                    // this.speRelAbundGraph.push(trace2)                    
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadPairInfo(){
            axios.post(this.server_add+'query/getPairInfo',
            {
                hRunId:this.humanRunId,
                mRunId:this.mouseRunId
            }).then(retDat => {
                if(retDat.status === 200){
                    this.hmPairInfo = retDat.data[0]
                    if(this.hmPairInfo != undefined){
                        this.hasHmPair = true;
                    }
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadGenRelAbundance(){
            axios.post(this.server_add+'query/getGenusRelAbundFPair',
            {
                genus:this.genusName
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    this.rel_gen_abn_data = inDat
                    this.relGentotalRows = retDat.data.length
                    this.rel_gen_abn_isBusy = false
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadSpeRelAbundance(){
            axios.post(this.server_add+'query/getSpeciesRelAbundFPair',
            {
                species:this.speciesName
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    this.rel_spe_abn_data = retDat.data
                    this.relSpetotalRows = retDat.data.length
                    this.rel_spe_abn_isBusy = false
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadSpeRelAbundBxPlot(){
            axios.post(this.server_add+'query/getSpeciesRelAbundBxPlotDat',
            {
                species:this.speciesName
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    var trace = {
                            x:inDat.human,
                            type:'box',
                            name:'Human'
                    }
                    this.speRelAbundGraphBx.push(trace)
                    var trace2 = {
                            x:inDat.mouse,
                            type:'box',
                            name:'Mouse'
                    }
                    this.speRelAbundGraphBx.push(trace2)
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadGenRelAbundBxPlot(){
            axios.post(this.server_add+'query/getGenusRelAbundBxPlotDat',
            {
                genus:this.genusName
            }).then(retDat => {
                if(retDat.status === 200){
                    var inDat = retDat.data
                    var trace = {
                            x:inDat.human,
                            type:'box',
                            name:'Human'
                    }
                    this.genRelAbundGraphBx.push(trace)
                    var trace2 = {
                            x:inDat.mouse,
                            type:'box',
                            name:'Mouse'
                    }
                    this.genRelAbundGraphBx.push(trace2)
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        checkStatus(){
            if(this.loadCounter>=3){
                this.showPage = true
            }
        } 
    },
    watch: {
        loadCounter: function(newValue, oldValue) {
            if(this.typ === 0){
                this.showPage   = newValue>=3
            }else if(this.typ === 1){
                this.showPage   = newValue>=2
            }else{
                this.showPage   = newValue>=2
            }
        }
    },
}
</script>

<style lang="less">
#boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
}
</style>